module.exports = __webpack_public_path__ + "static/media/sbu_logo.7f2739fb.svg";